import styled from '@themes/theme'


export const CasinoOpenWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 360px;
  transform: translate(-50%,-55%);
  .go-casino-btn {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 160px;
    height: 30px;
  }
`
